import React from "react";
import Navbar from "../../layout/Navbar";
import Footer from "../../layout/Footer";
import pcpfblocks from "../../assets/Our Products/Pre Cast Pre Fire Blocks/pcpf-blocks.jpg";

const Pre_Cast_Pre_Fire_Blocks = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* About Pre-Cast Pre-Fire Blocks Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
          {/* Text Section */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              About <span className="text-orange-600">Pre-Cast Pre-Fire Blocks</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              JANTA Group is highly specialized in manufacturing precast refractory shapes for a variety of materials, for use in many industries. Precast refractory shapes are pre fired and can be put right into service in your high temperature application.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              Precast Shapes are manufactured using high quality castable mixes. Insulating, Abrasion Resistant, Low Cement, No Cement, and conventional mixes are available. Alumina contents from 50-90% are available.
            </p>
          </div>

          {/* Image Section */}
          <div className="flex justify-center md:justify-end relative">
            <img
              src={pcpfblocks}
              alt="Pre-Cast Pre-Fire Blocks"
              className="w-80 h-80 object-cover rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </section>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
          opacity: 0;
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default Pre_Cast_Pre_Fire_Blocks;

